import React from 'react';
import { useEffect, useRef, useState } from 'react';
import Header from './Header2.0';
import HeaderSimple from './HeaderSimple';

import Footer from './Footer';
import SEO from '../SEO/SEO';
import {
  withMobileAppMode,
  GoTo,
  useAppContext,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import DeveloperOptions from '../DeveloperOptions/DeveloperOptionsContainer';
import HeaderSimpleWithMenu from './HeaderSimpleWithMenu';
import FooterSimple from './FooterSimple';

interface ILayoutProps {
  children: React.ReactNode;
  scrollY?: boolean;
  mobileAppMode?: boolean;
  simpleLayout?: boolean;
  id?: string;
}

const Layout: React.FC<ILayoutProps> = ({
  children,
  scrollY = true,
  mobileAppMode,
  simpleLayout = false,
  id,
}) => {
  const {
    images: { networkErrorImg },
    consts: { APP_BRAND },
  } = useAppContext();

  const layoutRef = useRef<HTMLDivElement>(null);
  const [clientY, setClientY] = useState(0);

  useEffect(() => {
    detectRefresh();
  }, []);

  useEffect(() => {
    // handle pull to refresh
    layoutRef.current?.addEventListener('touchstart', handleTouchStart);
    // layoutRef.current?.addEventListener('touchend', handleTouchEnd);
    return () => {
      layoutRef.current?.removeEventListener('touchstart', handleTouchStart);
      // layoutRef.current?.removeEventListener('touchend', handleTouchEnd);
    };
  }, [clientY]);

  const handleTouchStart = (event: any) => {
    setClientY(event.touches[0].clientY);

    if (layoutRef.current?.scrollTop === 0) {
      callNativeMobileApp({
        action: 'pull_to_refresh',
        payload: {
          isOnTop: true,
        },
      });
    } else {
      callNativeMobileApp({
        action: 'pull_to_refresh',
        payload: {
          isOnTop: false,
        },
      });
    }
  };

  // const handleTouchEnd = (event: any) => {
  //   const deltaY = event.changedTouches[0].clientY - clientY;

  //   if (layoutRef.current?.scrollTop === 0 && deltaY > 0) {
  //     callNativeMobileApp({
  //       action: 'pull_to_refresh',
  //     });
  //   }
  // };

  const renderHeader = () => {
    if (!mobileAppMode) {
      if (simpleLayout) {
        if (
          APP_BRAND === 'dtbaPl' ||
          APP_BRAND === 'dtbaEn' ||
          APP_BRAND === 'dtbaDe' ||
          APP_BRAND === 'hashimotoPl'
        ) {
          return <HeaderSimpleWithMenu />;
        }
        return <HeaderSimple />;
      }
      return <Header />;
    }
    return null;
  };

  const renderFooter = () => {
    if (!mobileAppMode) {
      if (simpleLayout) {
        return <FooterSimple />;
      }

      return <Footer />;
    }

    return null;
  };

  // clear apollo cache on refresh
  const detectRefresh = () => {
    if (!mobileAppMode) {
      window.onbeforeunload = () => {
        console.log('clear apollo-cache-persist');
        localStorage.removeItem('apollo-cache-persist');
      };
    }
  };

  return (
    <div id="layout" className={`layout ${!scrollY ? 'no-scrollY' : ''}`} ref={layoutRef}>
      <SEO />
      <GoTo />
      <DeveloperOptions />
      <div id={id}>
        {renderHeader()}
        <div className={mobileAppMode ? 'mobile-app-mode' : ''}>{children}</div>
        {renderFooter()}
      </div>
      {/* hack to preload network error image when there is no internet connection */}
      <img src={networkErrorImg} className="d-none" alt="" />
    </div>
  );
};
export default withMobileAppMode(Layout);
